import { type Component } from "vue";
import { defineStore } from "pinia";
import type { Options } from "./types";

export const useModal = defineStore("Modal", {
  state: () => ({
    callback: undefined as (() => void) | undefined,
    component: undefined as Component | undefined,
    options: {} as Options,
  }),

  actions: {
    open(component: Component, callback: () => void, options?: Options) {
      this.callback = callback;
      this.component = component;
      this.options = options ?? {};
    },

    accept() {
      this.callback!();
      this.close();
    },

    close() {
      this.$reset();
    },
  },
});
